/* Doe-het-zelf-zaak: rustige animaties en kleine UX-hulpjes.
   Respecteert "beperk beweging" in de instellingen van de bezoeker. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* 1. Secties en kaarten laten verschijnen tijdens het scrollen */
  function markReveal() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function (section, i) {
      if (i === 0) return;
      section.querySelectorAll('.title-wrapper-with-link, .title-wrapper, .collection-list-title, .dhz-section-head, .dhz-faq__intro').forEach(function (el) {
        el.classList.add('dhz-reveal');
      });
      section.querySelectorAll('.grid').forEach(function (grid) {
        Array.prototype.forEach.call(grid.children, function (item, n) {
          item.classList.add('dhz-reveal');
          item.style.setProperty('--d', Math.min(n, 6) * 0.07 + 's');
        });
      });
      section.querySelectorAll('.dhz-faq__list, .dhz-about, .newsletter__wrapper').forEach(function (el) {
        el.classList.add('dhz-reveal');
      });
    });
  }

  function startReveal() {
    var els = document.querySelectorAll('.dhz-reveal');
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    document.documentElement.classList.add('dhz-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  /* 2. Header: subtiele lijn en schaduw zodra je scrolt */
  function headerBehaviour() {
    function onScroll() {
      document.body.classList.toggle('dhz-scrolled', window.scrollY > 8);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 3. Wisselende zoeksuggesties in de hero */
  function rotatingPlaceholder() {
    var input = document.querySelector('[data-dhz-suggestions]');
    if (!input || reduce) return;
    var words = (input.getAttribute('data-dhz-suggestions') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (words.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (document.activeElement === input || input.value) return;
      input.classList.add('is-fading');
      setTimeout(function () {
        i = (i + 1) % words.length;
        input.placeholder = 'Zoek op ' + words[i];
        input.classList.remove('is-fading');
      }, 250);
    }, 2600);
  }

  /* 4. Winkelwagenteller laten opveren na toevoegen */
  function cartBump() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      var bubble = document.querySelector('.cart-count-bubble');
      var icon = document.getElementById('cart-icon-bubble');
      var el = bubble || icon;
      if (!el) return;
      el.classList.remove('dhz-bump');
      void el.offsetWidth;
      el.classList.add('dhz-bump');
    });
  }

  function init() {
    markReveal();
    startReveal();
    headerBehaviour();
    rotatingPlaceholder();
    cartBump();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* In de thema-editor alles meteen tonen */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.dhz-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
